export const lang = {
  ar: {
    home: "الرئيسية",
    cont: "ساتك للمقاولات",
    equipments: "ساتك للمعدات",
    transport: "ساتك للنقل",
    jobs: "الوظائف",
    apply: "التقدم للوظيفة",
    jobApp: "تقديم طلب على الوظيفة",
    jobDesc: "وصف الوظيفة",
    send: "إرسال",
    cancel: "إلغاء",
    name: "الإسم",
    phone: "رقم الهاتف",
    dob: "تاريخ الميلاد",
    email: "البريد الإلكتروني",
    country: "البلد",
    cv: "السيرة الذاتية",
    choose: "اختر",
    uploadMsg: "إسحب الملفات وافلتها هنا أو استعرض",
    jobAppSuccessMsg: "تم إستلام طلب التقدم للوظيفة",
    browseSites: "إختر تصفح واحد من موقعنا",
    contact: "إتصل بنا",
    copyrights: "حقوق النشر @ 2021. جميع الحقوق محفوظة",
    heroHeading: "الريادة في التنفيذ",
    aboutH: "من نحن؟",
    cvLinkText: "ملف تعريفي عن الشركة",
    vision: "الرؤية",
    msg: "الرسالة",
    principles: "قيمنا",
    discoverMore: "اكتشف المزيد",
    lNews: "آخر الأخبار",
    work: "أعمالنا",
    moreDetails: "المزيد من التفاصيل",
    partners: "شركائنا",
    successPartners: "شركاء النجاح",
    partnersDesc:
      "تعاونت الشركة خلال السنوات القليلة الماضية مع العديد من الشركاء المميزين",
    certificates: "شهاداتنا",
    certificatesDesc:
      "حصدت الشركة خلال السنوات القليلة الماضية علي العديد من الشهادات المعتمدة دوليا و محليا",
    moreNews: "المزيد من الأخبار",
    structure: "الهيكل التنظيمي",
    branches: "الفروع",
    cBranches: "فروع الشركة",
    branchesDesc:
      "على مدى اكثر من 47 عاما، استطاعت الشركة تاسيس اكتر من 6 فروع علي نطاق المملكة العربية السعودية",
    phoneValidation: "تأكد من إدخال الهاتف بصورة سليمة",
    about: "عن الشركة",
    sanitation: "مشاريع الصرف الصحي",
    water: "مشاريع المياه",
    electricity: "مشاريع الكهرباء",
    well: "مشاريع الآبار",
    roads: "مشاريع الطرق",
    satc: "ساتك",
    underDev: "الموقع تحت التطوير",
    agencies: "وكالاتنا",
    news: "الأخبار",
  },
  en: {
    home: "Home Page",
    cont: "SATC Contracting",
    equipments: "SATC Machinery",
    transport: "SATC Transportation",
    jobs: "Jobs",
    apply: "Apply for a job",
    jobApp: "Submit a job application",
    jobDesc: "Job Description",
    send: "Submit",
    cancel: "Cancel",
    name: "Name",
    phone: "Tel. No.",
    dob: "Date of Birth",
    email: "Email",
    country: "Country",
    cv: "CV",
    choose: "Select",
    uploadMsg: "Drag and Drop Files here or Browse",
    jobAppSuccessMsg: "Job Application Received",
    browseSites: "Select One Browse from our Website",
    contact: "Contact Us",
    copyrights: "Copyright@2021. All rights reserved.",
    heroHeading: "Leadership in implementation",
    aboutH: "Who are We?",
    cvLinkText: "Company Profile",
    vision: "Our Vision",
    msg: "Our Mission",
    principles: "Our Values",
    discoverMore: "See More",
    lNews: "Latest News",
    work: "Our Works",
    moreDetails: "Further Details",
    partners: "Our Partners",
    successPartners: "Success Partners",
    partnersDesc:
      "The Company collaborated with special partners during the recent few years",
    certificates: "Our Certificates",
    certificatesDesc:
      "The Company was awarded several internationally and locally accredited certificates during the recent few years",
    moreNews: "More news",
    structure: "Organizational Chart",
    branches: "Branches",
    cBranches: "Company's Branches",
    branchesDesc:
      "For more than 47 years, the company was able to establish more than 6 branches across the Kingdom of Saudi Arabia",
    phoneValidation: "Make sure that phone No. is entered properly",
    about: "About SATC",
    sanitation: "Sewage projects",
    water: "Water Projects",
    electricity: "Electricity Projects",
    well: "Well Projects",
    roads: "Road Projects",
    satc: "SATC",
    underDev: "Website under Development",
    agencies: "Agencies",
    news: "News",
    bestEquip: "Best Equipments",
    ourAgencies: "Our agencies",
    agency: "Agency",
    noContent: "No content",
  },
};
